import { QuestionCircleOutlined } from '@ant-design/icons'
import { Popover, Table } from 'antd'

const columns = [
  {
    dataIndex: 'range',
    title: '成交金额（X）范围',
    width: 240
  },
  {
    dataIndex: 'formula',
    title: '服务费收取方式',
    width: 300
  }
]

const dataSource = [
  {
    range: 'X ≤ 300 万元',
    formula: '2‰'
  },
  {
    range: '300 万元 < X ≤ 500 万元',
    formula: '300 万元 * 2‰ + ( X - 300 万元 ) * 1.8‰'
  },
  {
    range: '500 万元 < X ≤ 700 万元',
    formula: '300 万元 * 2‰ + ( X - 300 万元 ) * 1.5‰'
  },
  {
    range: '700 万元 < X ≤ 9000 万元',
    formula: '300 万元 * 2‰ + ( X - 300 万元 ) * 1.2‰'
  },
  {
    range: '900 万元 < X ≤ 11000 万元',
    formula: '300 万元 * 2‰ + ( X - 300 万元 ) * 0.9‰'
  },
  {
    range: 'X > 11000 万元',
    formula: '300 万元 * 2‰+ ( X - 300 万元 ) * 0.5‰'
  }
]

export const ServiceFeeGradientTooltip = () => {
  return (
    <Popover
      title='梯度策略计费详情'
      content={
        <Table
          bordered
          columns={columns}
          dataSource={dataSource}
          pagination={false}
          rowKey={'range'}
        />
      }
    >
      <QuestionCircleOutlined />{' '}
    </Popover>
  )
}
